import { render, staticRenderFns } from "./MpmField.vue?vue&type=template&id=775c5686&scoped=true"
import script from "./MpmField.vue?vue&type=script&lang=js"
export * from "./MpmField.vue?vue&type=script&lang=js"
import style0 from "./MpmField.vue?vue&type=style&index=0&id=775c5686&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775c5686",
  null
  
)

export default component.exports